import { InputField } from "@/components/input-field/InputField";
import { SelectComponent } from "@/components/select/Select";
import { Sucursal } from "@/services/accounts.service";
import { AppColors } from "@/styles/colors";
import { standardNamePatternOne } from "@/utils/reg-expressions";
import { Card, Field, Flex, Grid, GridItem } from "@chakra-ui/react";
import { Control, FieldErrors } from "react-hook-form";
import { ProductionZoneCreationForm } from "../create/schema/production-zone-creation.schema";

interface Props {
  control: Control<ProductionZoneCreationForm>;
  errors: FieldErrors<ProductionZoneCreationForm>;
  sucursales: Sucursal[];
  isActive: boolean;
  loading: boolean;
  loadingSucursales: boolean;
  showStatusField?: boolean;
}

export const ProductionZoneForm = ({
  control,
  errors,
  sucursales,
  isActive,
  loading,
  loadingSucursales,
  showStatusField,
}: Props) => {
  return (
    <Flex flexDir="column" gap="24px" marginTop="30px">
      <Card.Root maxW="full" borderRadius="8px">
        <Card.Body
          paddingX="32px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Grid templateColumns="repeat(4, 1fr)" gap={6}>
            <GridItem>
              <InputField
                inputName="nombre"
                labelText="Nombre Zona Productiva"
                placeholder="Ingresar"
                control={control as any}
                disabled={loading || !isActive}
                allowedPattern={standardNamePatternOne}
                required
                minHeight="40px"
              />
            </GridItem>

            <GridItem>
              <Field.Root invalid={!!errors?.zonaComercial}>
                <SelectComponent
                  name="zonaComercial"
                  items={
                    sucursales?.map((el) => ({
                      label: el.nombre,
                      value: String(el.clave),
                    })) ?? []
                  }
                  labelText="Zona Comercial"
                  placeholder="Seleccionar"
                  control={control as any}
                  clearable
                  disabled={loading || loadingSucursales || !isActive}
                  loading={loading || loadingSucursales}
                  minHeight="40px"
                  required
                />
                <Field.ErrorText>
                  {String(errors?.zonaComercial?.message ?? "")}
                </Field.ErrorText>
              </Field.Root>
            </GridItem>

            {showStatusField && (
              <GridItem>
                <Field.Root invalid={!!errors?.activo}>
                  <SelectComponent
                    name="activo"
                    items={[
                      { label: "Activa", value: true },
                      { label: "Inactiva", value: false },
                    ]}
                    labelText="Estado"
                    placeholder="Seleccionar"
                    control={control as any}
                    clearable
                    disabled={loading || !isActive}
                    minHeight="40px"
                    required
                  />
                  <Field.ErrorText>
                    {String(errors?.activo?.message ?? "")}
                  </Field.ErrorText>
                </Field.Root>
              </GridItem>
            )}
          </Grid>
        </Card.Body>
      </Card.Root>
    </Flex>
  );
};
